import { createFileRoute, redirect } from '@tanstack/react-router'

import { isFeatureFlagEnabled } from '@/utils/is-feature-flag-enabled'

export const Route = createFileRoute('/_auth/curricula')({
  beforeLoad: async ({ context }) => {
    if (
      !context.authStore?.user?.isGeneratorAdmin ||
      !isFeatureFlagEnabled('IS_CURRICULUMS_MANAGEMENT_MODULE_ENABLED')
    )
      throw redirect({ replace: true, to: '/' })
  }
})
